<template>
  <iframe
    :src="linkQualificacao"
    frameborder="0"
    title="Qualificação"
    width="100%"
    height="100%"
  ></iframe>
</template>

<script>
import Constants from '@/services/Constants.js';
import _UserService from '@/services/UserService.js';

const UserService = _UserService();
export default {
  name: 'Qualificacao',
  data: function() {
    return {
      
    }
  },
  mounted: function() {
  },
  computed: {
    linkQualificacao: function() {
      if(!UserService.hasPermission(10, 'R')){
        this.$router.push({ path: '/inteligencia/calculadora-mercado' });
        return null;
      } else {
        if(window.location.host.includes('localhost')){
          return Constants.app.link_qualificacao_hml;
        }
        else if(window.location.host.includes('hml')){
          return Constants.app.link_qualificacao_hml;
        } else {
          return Constants.app.link_qualificacao_prod;
        } 
      }
    }
  }
};
</script>

<style>
</style>